__turbopack_context__.v({
  "answerCard": "twin-story-module__WmRAFa__answerCard",
  "chapterNav": "twin-story-module__WmRAFa__chapterNav",
  "chapterRule": "twin-story-module__WmRAFa__chapterRule",
  "compactStory": "twin-story-module__WmRAFa__compactStory",
  "connectedCards": "twin-story-module__WmRAFa__connectedCards",
  "customerConnections": "twin-story-module__WmRAFa__customerConnections",
  "customerFocus": "twin-story-module__WmRAFa__customerFocus",
  "evidence": "twin-story-module__WmRAFa__evidence",
  "evidenceFoot": "twin-story-module__WmRAFa__evidenceFoot",
  "evidenceGrid": "twin-story-module__WmRAFa__evidenceGrid",
  "evidenceHeader": "twin-story-module__WmRAFa__evidenceHeader",
  "evidenceIntro": "twin-story-module__WmRAFa__evidenceIntro",
  "flowArt": "twin-story-module__WmRAFa__flowArt",
  "flowCaption": "twin-story-module__WmRAFa__flowCaption",
  "flowLines": "twin-story-module__WmRAFa__flowLines",
  "flowTwin": "twin-story-module__WmRAFa__flowTwin",
  "footer": "twin-story-module__WmRAFa__footer",
  "hint": "twin-story-module__WmRAFa__hint",
  "kicker": "twin-story-module__WmRAFa__kicker",
  "landingStory": "twin-story-module__WmRAFa__landingStory",
  "layerButtons": "twin-story-module__WmRAFa__layerButtons",
  "layerCaption": "twin-story-module__WmRAFa__layerCaption",
  "layerCopy": "twin-story-module__WmRAFa__layerCopy",
  "layerDetail": "twin-story-module__WmRAFa__layerDetail",
  "layerGrid": "twin-story-module__WmRAFa__layerGrid",
  "layerVisual": "twin-story-module__WmRAFa__layerVisual",
  "layers": "twin-story-module__WmRAFa__layers",
  "miniRecord": "twin-story-module__WmRAFa__miniRecord",
  "page": "twin-story-module__WmRAFa__page",
  "pageNav": "twin-story-module__WmRAFa__pageNav",
  "particleLayer": "twin-story-module__WmRAFa__particleLayer",
  "particlePath": "twin-story-module__WmRAFa__particlePath",
  "particles": "twin-story-module__WmRAFa__particles",
  "proofAnswer": "twin-story-module__WmRAFa__proofAnswer",
  "proofCard": "twin-story-module__WmRAFa__proofCard",
  "proofQuestion": "twin-story-module__WmRAFa__proofQuestion",
  "proofSource": "twin-story-module__WmRAFa__proofSource",
  "scrollReset": "twin-story-module__WmRAFa__scrollReset",
  "sourceButtons": "twin-story-module__WmRAFa__sourceButtons",
  "sourceIcon": "twin-story-module__WmRAFa__sourceIcon",
  "sourceLabels": "twin-story-module__WmRAFa__sourceLabels",
  "statusDot": "twin-story-module__WmRAFa__statusDot",
  "sticky": "twin-story-module__WmRAFa__sticky",
  "story": "twin-story-module__WmRAFa__story",
  "storyArt": "twin-story-module__WmRAFa__storyArt",
  "storyCopy": "twin-story-module__WmRAFa__storyCopy",
  "storyHead": "twin-story-module__WmRAFa__storyHead",
  "studyIntro": "twin-story-module__WmRAFa__studyIntro",
  "textButton": "twin-story-module__WmRAFa__textButton",
  "trail": "twin-story-module__WmRAFa__trail",
  "trailMove": "twin-story-module__WmRAFa__trailMove",
  "workspaceStage": "twin-story-module__WmRAFa__workspaceStage",
});
